import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {UserRoleService} from '../services/user-role.service';
import {ConstantsService} from '../../../../services/constants.service';
import {AdminService} from '../../../../services/admin.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {Observable} from 'rxjs/Observable';

declare const swal;
declare const toastr: any;

@Component({
    selector: 'amenity-permissions-view',
    templateUrl: './amenity-permissions-view.component.html',
    styleUrls: ['./amenity-permissions-view.component.scss']
})
export class AmenityPermissionsViewComponent implements OnInit {
    @ViewChild('form') form;
    @Input() close;
    @Input() role;
    private services: Object = {};
    public serviceNames: Array<string> = [];
    private initialItemData: any;
    public isCurrentRole = false;
    public isCanEdit = true;
    public amenityPermissions = [];
    public showSpinner = false;
    public disabledSubmit = false;
    constructor(public userRoleService: UserRoleService,
                public adm: AdminService,
                public api: ApiClientService) {
    }

    ngOnInit() {
        this.getAmenityPermissions();
    }

    onSubmit(form: NgForm) {
        swal(ConstantsService.getSwalConfig(
            'Update amenity permissions',
            'Are you sure you would like to update amenity permissions?'),
            (res) => {
                if (res)
                    this.updateAmenityPermissions();
                else
                    this.amenityPermissions = JSON.parse(JSON.stringify(this.initialItemData));
            }
        );
    }

    selectAll(type, event) {
        this.serviceNames.forEach(name => {
            this.services[name][type[0]] = event.target.checked;
        });
    }

    selectRead(event, serviceItem) {
        if (!event.target.checked) {
            serviceItem.rolePermissions.u = false;
            serviceItem.rolePermissions.c = false;
            serviceItem.rolePermissions.d = false;
            serviceItem.rolePermissions.a = false;
            serviceItem.rolePermissions.s = false;
        }
    }

    selectUpdate(event, serviceItem, type) {
        if (type === 'c') {
            serviceItem.rolePermissions.u = event.target.checked;
        } else {
            serviceItem.rolePermissions.c = event.target.checked;
        }
        if (!event.target.checked) {
            serviceItem.rolePermissions.d = false;
            serviceItem.rolePermissions.a = false;
            serviceItem.rolePermissions.s = false;
        }
    }

    checkForChanges(): boolean {
        let changed = false;
        // if(this.initialItemData) {
        //     this.initialItemData.forEach(initialItem => {
        //         this.userRoleService.amenityPermissions.forEach( item => {
        //             if(item.id == initialItem.id) {
        //                 Object.keys(item.permissions).forEach(key => {
        //                     if(initialItem[key] != item[key])
        //                         changed = true;
        //                 });
        //             }
        //         });
        //     });
        // }
        return changed;
    }

    checkAllPermissions(event, item): void {
        item.rolePermissions.r = event.target.checked;
        item.rolePermissions.c = event.target.checked;
        item.rolePermissions.u = event.target.checked;
        item.rolePermissions.d = event.target.checked;
        item.rolePermissions.a = event.target.checked;
        item.rolePermissions.s = event.target.checked;
    }

    allPermissionsAreChecked(item): boolean {
        let allChecked = false;
        if(item.rolePermissions.r && item.rolePermissions.c && item.rolePermissions.u &&
           item.rolePermissions.d && item.rolePermissions.a)
           // item.rolePermissions.d && item.rolePermissions.a && item.rolePermissions.s)
                allChecked = true;
        else
            allChecked = false;
        return allChecked;
    }

    checkEntireColumnPermissions(event, permission): void {
        this.amenityPermissions.forEach( item => {
            if (!((permission == 'c' || permission == 'u') && !item.rolePermissions.r)) {
                if (!(permission == 'd' && (!item.rolePermissions.c || !item.rolePermissions.u))) {
                    if (!(permission == 'a' && (!item.rolePermissions.c || !item.rolePermissions.u))) {
                        if (!(permission == 's' && (!item.rolePermissions.c || !item.rolePermissions.u))) {
                            item.rolePermissions[permission] = event.target.checked;
                            if ((permission == 'r' || permission == 'c' || permission == 'u') && !event.target.checked) {
                                const originalRead = item.rolePermissions.r;
                                this.checkAllPermissions(event, item);
                                if (permission == 'c' || permission == 'u') {
                                    item.rolePermissions.r = originalRead;
                                }
                            }
                            if ((permission == 'c' || permission == 'u') && event.target.checked) {
                                item.rolePermissions.c = event.target.checked;
                                item.rolePermissions.u = event.target.checked;
                            }
                        }
                    }
                }
            }
        });
    }

    allInColumnAreChecked(permission): boolean {
        let allChecked = true;
        this.amenityPermissions.forEach( item => {
            if(!item.rolePermissions[permission])
                 allChecked = false;
        });
        return allChecked;
    }

    isColumnCheckboxDisabled(): boolean {
        let disabled = false;
        if(!this.userRoleService.account.canUpdate('auth') || this.isCurrentRole)
            disabled = true;
        return disabled;
    }

    updateAmenityPermissions() {
        let changable = [];
        if(this.initialItemData) {
            this.initialItemData.forEach(initialItem => {
                this.amenityPermissions.forEach( item => {
                    if(item.amenity.id == initialItem.amenity.id) {
                        Object.keys(item.rolePermissions).forEach(key => {
                            if(initialItem.rolePermissions[key] != item.rolePermissions[key]) {
                                if(!changable.find(c => c.amenity.id == initialItem.amenity.id))
                                    changable.push(item);
                            }
                        });
                    }
                });
            });
        }
        let observables = [];
        changable.forEach(c => {
            const data = {
                roleId: this.role.id,
                amenity: c.amenity.id,
                corporationNumberId: this.role.corporationNumberId,
                rolePermissions: c.rolePermissions
            };
            const url = `/v1/amenity_role${c.id ? `/${c.id}` : ''}.json`;
            observables.push(this.api[!c.id ? 'post' : 'patch']('domainAmenities', url, data));
        });
        if(observables.length > 0) {
            this.disabledSubmit = true;
            Observable.forkJoin(observables).subscribe(
                res => {
                    this.disabledSubmit = false;
                    toastr.success('Amenity permissions were updated successfully.');
                    res.forEach(
                        r => {
                            const index = this.amenityPermissions.findIndex(p => p.amenity.id == (<any>r).amenity);
                            this.amenityPermissions[index].id = (<any>r).id;
                            this.initialItemData[index].id = (<any>r).id;
                            this.initialItemData[index].rolePermissions = JSON.parse(JSON.stringify((<any>r).rolePermissions));
                        }
                    );
                }, error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Failed to update amenity permissions.');
                }
            );
        }
    }

    getAmenityPermissions(buildingId?) {
        this.showSpinner = true;
        this.amenityPermissions = [];
        this.userRoleService.getAmenityPermissions(this.role.id, buildingId).subscribe(
            res => {
                this.amenityPermissions = JSON.parse(res._body).entities || [];
                this.amenityPermissions.forEach(p => {
                    if(!p.rolePermissions)
                        p.rolePermissions = {c: 1, r: 1, u: 1, d: 1, a: 1, s: 1};
                });
                this.initialItemData = JSON.parse(JSON.stringify(this.amenityPermissions));
            },
            error => toastr.error('Failed to get Amenity Permissions'),
            () => this.showSpinner = false
        );
    }

    convertToSearchSelectFormat(arr: Array<any>) {
        return arr.map(template => ({value: template.id, optionText: template.name}));
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/amenity-permissions-view/amenity-permissions-view.component.ts